import { NgModule } from '@angular/core';
import { CartPageEventBuilder } from './cart-page-event.builder';

@NgModule({})
export class CartPageEventModule {
  constructor(_cartPageEventBuilder: CartPageEventBuilder) {}
}
